import React, { type ComponentType } from 'react';

import { useAdvertiserId } from 'src/app/views/hooks/useAdvertiserId';
import { useCurrentUser } from 'src/app/views/hooks/useCurrentUser';
import { useDataCleanup } from 'src/app/views/hooks/useDataCleanup';
import { useFlowType } from 'src/app/views/hooks/useFlowType';
import { useHirerAccountAndContractBalance } from 'src/app/views/hooks/useHirerAccountAndContractBalance';
import { useIdentity } from 'src/app/views/hooks/useIdentity';
import { useRedirectIfDraftIdNotSetInState } from 'src/app/views/hooks/useRedirectIfDraftIdNotSetInState';
import { useUserPermissions } from 'src/app/views/hooks/useUserPermissions';

export const withAppEnhancers =
  (WrappedComponent: ComponentType<any>) => (props: any) => {
    useRedirectIfDraftIdNotSetInState();
    useDataCleanup();
    useFlowType('create');
    useAdvertiserId();
    useCurrentUser();
    useUserPermissions();

    const { loading: isIdentityLoading } = useIdentity();
    const { loading: isHirerInfoLoading } = useHirerAccountAndContractBalance();

    if (isIdentityLoading || isHirerInfoLoading) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };
